// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__EU9nB","remove":"style_remove__ChISr"};